import { Stack, Typography } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Rejection = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);

  return (
    <Stack gap='20px'>
      <Typography variant='body6'>
        {dictionary.steps.rejection.info1}
      </Typography>
      <Typography variant='body5'>
        <strong>{dictionary.steps.rejection.info2title}</strong>
        {dictionary.steps.rejection.info2}
      </Typography>
      <Stack direction={isDesktop ? 'row' : 'column'} gap='4px'>
        <Typography variant='body6'>
          {dictionary.steps.rejection.extraDetails.text}
        </Typography>
        <LinkArrowLeft2
          href={`${process.env.REACT_APP_MARKETING_SITE_URL}${dictionary.steps.rejection.extraDetails.href}`}
          newWindow
          text={dictionary.steps.rejection.extraDetails.hrefText}
        />
      </Stack>
    </Stack>
  );
};
